import React from 'react';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';

import styles from './filters.module.scss';

const {
  slideArrow,
  hideSlideButton,
  leftArrowFade,
  rightArrowFade,
  arrowLeft,
  arrowRight,
  arrowFrame,
} = styles;

function Arrow({
  children,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
}) {
  return (
        <button
            className={slideArrow}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </button>
  );
}

export function LeftArrow() {
  const {
    isFirstItemVisible,
    scrollPrev,
    visibleItemsWithoutSeparators,
    initComplete,
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !initComplete || (initComplete && isFirstItemVisible),
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
        <div className={`${arrowFrame} ${arrowLeft} ${disabled ? hideSlideButton : ''}`}>
            <Arrow disabled={disabled} onClick={() => scrollPrev()}>
                <i className="ic icon-arrow-left"/>
            </Arrow>
            <div className={leftArrowFade}/>
        </div>
  );
}

export function RightArrow() {
  const {
    isLastItemVisible,
    scrollNext,
    visibleItemsWithoutSeparators,
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isLastItemVisible,
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
        <div className={`${arrowFrame} ${arrowRight} ${disabled ? hideSlideButton : ''}`}>
            <Arrow disabled={disabled} onClick={() => scrollNext()}>
                <i className="ic icon-arrow-right"/>
            </Arrow>
            <div className={rightArrowFade}/>
        </div>
  );
}
